/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HorseRegisterDto
 */
export interface HorseRegisterDto {
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HorseRegisterDto
     */
    breedId?: number;
    /**
     * 
     * @type {Date}
     * @memberof HorseRegisterDto
     */
    birthday?: Date;
    /**
     * 
     * @type {number}
     * @memberof HorseRegisterDto
     */
    colorId?: number;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    owner?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    mother?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    father?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof HorseRegisterDto
     */
    registerDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    bookerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    bookerEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    remark?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HorseRegisterDto
     */
    size?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    lNr?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HorseRegisterDto
     */
    fatherBreedId?: number;
    /**
     * 
     * @type {number}
     * @memberof HorseRegisterDto
     */
    motherBreedId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HorseRegisterDto
     */
    isBigHorse?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    fatherRegisterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    motherRegisterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    ownerRegisterId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    breeder?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseRegisterDto
     */
    breederRegisterId?: string | null;
}

/**
 * Check if a given object implements the HorseRegisterDto interface.
 */
export function instanceOfHorseRegisterDto(value: object): value is HorseRegisterDto {
    return true;
}

export function HorseRegisterDtoFromJSON(json: any): HorseRegisterDto {
    return HorseRegisterDtoFromJSONTyped(json, false);
}

export function HorseRegisterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HorseRegisterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'breedId': json['breedId'] == null ? undefined : json['breedId'],
        'birthday': json['birthday'] == null ? undefined : (new Date(json['birthday'])),
        'colorId': json['colorId'] == null ? undefined : json['colorId'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'mother': json['mother'] == null ? undefined : json['mother'],
        'father': json['father'] == null ? undefined : json['father'],
        'registerDate': json['registerDate'] == null ? undefined : (new Date(json['registerDate'])),
        'bookerId': json['bookerId'] == null ? undefined : json['bookerId'],
        'bookerEmail': json['bookerEmail'] == null ? undefined : json['bookerEmail'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'size': json['size'] == null ? undefined : json['size'],
        'lNr': json['lNr'] == null ? undefined : json['lNr'],
        'fatherBreedId': json['fatherBreedId'] == null ? undefined : json['fatherBreedId'],
        'motherBreedId': json['motherBreedId'] == null ? undefined : json['motherBreedId'],
        'isBigHorse': json['isBigHorse'] == null ? undefined : json['isBigHorse'],
        'fatherRegisterId': json['fatherRegisterId'] == null ? undefined : json['fatherRegisterId'],
        'motherRegisterId': json['motherRegisterId'] == null ? undefined : json['motherRegisterId'],
        'ownerRegisterId': json['ownerRegisterId'] == null ? undefined : json['ownerRegisterId'],
        'breeder': json['breeder'] == null ? undefined : json['breeder'],
        'breederRegisterId': json['breederRegisterId'] == null ? undefined : json['breederRegisterId'],
    };
}

export function HorseRegisterDtoToJSON(json: any): HorseRegisterDto {
    return HorseRegisterDtoToJSONTyped(json, false);
}

export function HorseRegisterDtoToJSONTyped(value?: HorseRegisterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'breedId': value['breedId'],
        'birthday': value['birthday'] == null ? undefined : (() => { const d = value['birthday']; return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` })(),
        'colorId': value['colorId'],
        'gender': value['gender'],
        'owner': value['owner'],
        'mother': value['mother'],
        'father': value['father'],
        'registerDate': value['registerDate'] == null ? undefined : ((value['registerDate']).toISOString()),
        'bookerId': value['bookerId'],
        'bookerEmail': value['bookerEmail'],
        'remark': value['remark'],
        'size': value['size'],
        'lNr': value['lNr'],
        'fatherBreedId': value['fatherBreedId'],
        'motherBreedId': value['motherBreedId'],
        'isBigHorse': value['isBigHorse'],
        'fatherRegisterId': value['fatherRegisterId'],
        'motherRegisterId': value['motherRegisterId'],
        'ownerRegisterId': value['ownerRegisterId'],
        'breeder': value['breeder'],
        'breederRegisterId': value['breederRegisterId'],
    };
}

